import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { GenericErrorResponse, UuidModel } from '../typings';
import { useCustomMutation } from '../utils/useCustomMutation';
import { POST_CREATE_RESIT_REGISTRATION } from '../../constants/apiUrls';

// =============================================================================
// Mutation
// =============================================================================

interface Input {
  onSuccess?: (data: UuidModel) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useStartCandidateResit = ({ onSuccess, onError }: Input) => {
  const usePostCreateResit = async (token?: string) => {
    const res = await axiosClient.post<UuidModel>(POST_CREATE_RESIT_REGISTRATION(token));
    return res.data;
  };
  return useCustomMutation(usePostCreateResit, {
    onSuccess,
    onError,
  });
};
